// extracted by mini-css-extract-plugin
export default {"innerWrapper":"is-z","tooltipWrapper":"js-z","icon":"ks-z","tooltip":"ls-z","content":"ms-z"};